import React from "react";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { useTitleState } from "@/context/TitleContext";

const Breadcrumbs: React.FC = () => {
  const title = useTitleState();
  const items = title.Breadcrumbs || [];

  if (items.length === 0) return null;

  return <Breadcrumb breadcrumbItems={items} />;
};

export default Breadcrumbs;
